import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { actions as dashboardActions } from '@store/ducks/dashboard';
import useDashboardExport from '@hooks/useDashboardExport';

// Partials
import { Title, Box } from '@components';
import IconDashboard from '@icons/rectangle.svg';
import { getPreviousDate, getDateNowServer } from '@utils';
import GraphSkeleton from '@icons/graph-skeleton.svg';
import ChartHeader from './ChartHeader';
import Chart from './Chart';

// Components

// Icons component

// Style
import {
  ChartContainer,
  IconSkeletonContainer,
  BoxSkeletonContainer,
} from '../Styled';

// UTILS

const ChartStudyHours = () => {
  const [filterDatePreviousDay, setFilterDatePreviousDay] = useState(7);
  const [filterGroups, setFilterGroups] = useState([]);
  const { exportChartSessions } = useDashboardExport();

  const getFilterDate = (number) => setFilterDatePreviousDay(number);
  const getFilterGroups = (str) => setFilterGroups(str);
  const dispatch = useDispatch();
  const userReducer = useSelector((state) => state.user);
  const stepUserCompleted = !!(userReducer?.users?.length > 0);

  const getExportParams = () => ({
    date_start: getPreviousDate(filterDatePreviousDay),
    date_end: getDateNowServer(),
    groups: filterGroups,
  });

  const handleExport = () => exportChartSessions(getExportParams());

  const handleFilters = () => {
    const date_start = getPreviousDate(filterDatePreviousDay);
    const date_end = getDateNowServer();
    const groups = filterGroups;
    const params = {
      date_start,
      date_end,
      groups,
    };

    dispatch(dashboardActions.getGraphicStudyHoursRequest({ params }));
  };

  useEffect(() => {
    if (filterDatePreviousDay || filterGroups) handleFilters();
  }, [filterDatePreviousDay, filterGroups]);

  return (
    <>
      <Title
        title="Horas de estudos"
        subtitle="Veja quantas horas de estudos seus colaboradores estão dedicando diariamente, você também poderá filtrar por períodos e grupos."
      />

      {stepUserCompleted ? (
        <Box>
          <ChartContainer>
            <ChartHeader
              getFilterDate={getFilterDate}
              getFilterGroups={getFilterGroups}
              onDownload={handleExport}
            />
            <Chart />
          </ChartContainer>
        </Box>
      ) : (
          <BoxSkeletonContainer>
            <Box>
              <IconSkeletonContainer>
                <GraphSkeleton />
              </IconSkeletonContainer>
            </Box>
          </BoxSkeletonContainer>
        )}
    </>
  );
};

export default ChartStudyHours;
export { ChartStudyHours };
